/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { useField, useFormikContext } from 'formik';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useCheckoutStore } from '../../Hooks/Zustand/useCheckoutStore';

/**
 * Form DatePickerField Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function DatePickerField(props) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const {
    setLastValidStep,
    getActiveStep,
  } = useCheckoutStore();

  return (
    <DatePicker
      {...field}
      {...props}
      value={dayjs(field.value)}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val.toString());
        setLastValidStep(getActiveStep());
      }}
      slotProps={{
        textField: {
          required: true,
        },
      }}
    />
  );
}
